export const TD_MULTIPLIER = 1; // Fator de conversão do TD para distância real em mm 